/* eslint-disable @typescript-eslint/no-non-null-assertion */
import md5 from 'md5';
import { encode } from 'base64-arraybuffer';

const hexToArrayBuffer = (hex: string): ArrayBuffer => {
  const typedArray = new Uint8Array(
    hex.match(/.{1,2}/g)!.map((byte) => parseInt(byte, 16)),
  );
  return typedArray.buffer;
};

export const calculateMD5 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      if (e.target && e.target.result) {
        const arrayBuffer = e.target.result as ArrayBuffer;
        const hexMd5Hash = md5(new Uint8Array(arrayBuffer));
        const arrayBufferMd5Hash = hexToArrayBuffer(hexMd5Hash);
        const base64Md5Hash = encode(arrayBufferMd5Hash);
        resolve(base64Md5Hash);
      } else {
        reject(new Error('Failed to read the file'));
      }
    };

    fileReader.onerror = () => {
      reject(new Error('File read error'));
    };

    fileReader.readAsArrayBuffer(file);
  });
};
